function handlefactbox () {
	function debounce (func, delay) {
		let timeout

		return function () {
			const context = this
			const args = arguments
			clearTimeout(timeout)
			timeout = setTimeout(() => func.apply(context, args), delay)
		}
	}

	const items = document.querySelectorAll(".factbox")
	items.forEach(item => {
		const buttonOpen = item.querySelector(".factbox__button--open")
		const buttonClose = item.querySelector(".factbox__button--close")

		const content = item.querySelector(".factbox__content")
		const wrapper = item.querySelector(".factbox__wrapper")

		buttonOpen.addEventListener("click", _event => {
			item.setAttribute("aria-expanded", "true")
			content.style.height = `${wrapper.getBoundingClientRect().height}px`
		})

		buttonClose.addEventListener("click", _event => {
			item.setAttribute("aria-expanded", "false")
			content.style.height = null
		})

		window.addEventListener('resize', debounce(() => {
			if (item.getAttribute('aria-expanded') === 'true') {
				content.style.height = `${wrapper.getBoundingClientRect().height}px`
			}
		}, 175))

		window.addEventListener('resize', () => {
		})

		item.addEventListener("keydown", event => {
			if (document.activeElement === item && (event.key === " " || event.key === "Enter")) {
				event.preventDefault() // Prevent default action for space key to avoid page scroll
				if (item.getAttribute("aria-expanded") === "true") {
					item.setAttribute("aria-expanded", "false")
					content.style.height = null
				} else {
					item.setAttribute("aria-expanded", "true")
					content.style.height = `${wrapper.getBoundingClientRect().height}px`
				}
			}
		})
	})
}

document.addEventListener("DOMContentLoaded", () => {
	handlefactbox()
})
